import { render, staticRenderFns } from "./UploadFullScreenDialog.vue?vue&type=template&id=2ada6dd9&scoped=true"
import script from "./UploadFullScreenDialog.vue?vue&type=script&lang=ts"
export * from "./UploadFullScreenDialog.vue?vue&type=script&lang=ts"
import style0 from "./UploadFullScreenDialog.vue?vue&type=style&index=0&id=2ada6dd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada6dd9",
  null
  
)

export default component.exports